import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=51ccf776&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ccf776')) {
      api.createRecord('51ccf776', component.options)
    } else {
      api.reload('51ccf776', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=51ccf776&", function () {
      api.rerender('51ccf776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/ResetPassword/ResetPassword.vue"
export default component.exports